import Insight from "../insightClass";
import React from "react";
import { insight30Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight089 = new Insight(
  "16 January 2026",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight30Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2026-01-16)",
  "",
  `The UK’s Allocation Round 7 awarded a record 8.4 GW of offshore wind capacity. RWE secured the largest share, totalling 6.9 GW across several major projects, while SSE also obtained significant capacity. Fixed-bottom strike prices were notably higher than in the early ultra-low-price era, while two floating projects cleared at much higher prices, reflecting a policy approach focused on limited scale and technology learning.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2026-01-16)</h1>
    <h2></h2>
    <p className="article-date">16 January 2026</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. UK AR7 delivers a record 8.4 GW, marking a shift toward deliverable
      pricing
    </h3>
    <p>
      The UK’s Allocation Round 7 awarded a record 8.4 GW of offshore wind
      capacity. RWE secured the largest share, totalling 6.9 GW across several
      major projects, while SSE also obtained significant capacity. Fixed-bottom
      strike prices were notably higher than in the early ultra-low-price era,
      while two floating projects cleared at much higher prices, reflecting a
      policy approach focused on limited scale and technology learning. Overall,
      AR7 prioritised deliverability over headline-low pricing, balancing
      financing costs, supply chain realities and system security.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The real significance of AR7 lies in the return of deliverability as the
      guiding principle. The UK has accepted that offshore wind must be priced
      closer to real costs under today’s macro conditions. For developers, CfDs
      are only the starting point—financing execution and supply-chain
      coordination will define success. For policymakers, the challenge is
      ensuring grids, ports and installation capacity expand in step with
      awarded volumes.
    </p>
    <h3>2. EnBW exits Mona and Morgan, booking a €1.2bn impairment</h3>
    <p>
      EnBW announced it will not proceed with the Mona and Morgan offshore wind
      projects in the UK and will record a €1.2bn impairment. The two projects
      total around 3 GW of potential capacity but failed to secure support in
      the latest auction. EnBW cited rising supply-chain costs, changing power
      price expectations, higher financing costs and increasing execution risk
      as key factors behind its decision.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This move highlights that auction success alone no longer guarantees
      investment viability. Even experienced European developers are reassessing
      risk-return thresholds. The UK may see greater concentration among
      financially and operationally resilient players, while some projects are
      restructured or dropped—raising questions about long-term pipeline depth
      and supply-chain confidence.
    </p>
    <h3>3. RWE brings in KKR on the 3.1 GW Norfolk Vanguard projects</h3>
    <p>
      RWE has partnered with global infrastructure investor KKR, which will
      acquire a 50% stake in both Norfolk Vanguard East and West, totalling 3.1
      GW. RWE has launched non-recourse project financing and targets
      transaction close and final investment decision in summer 2026, with
      commissioning around 2029–2030. The deal marks a transition from contract
      award to execution-focused delivery.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Equity recycling combined with project finance has become standard for
      mega-scale offshore wind. Competitive advantage now lies in how quickly
      developers can optimise capital structures and secure critical
      supply-chain capacity. 2026 will be a decisive year for locking in
      delivery slots across the UK pipeline.
    </p>
    <h3>4. Germany’s Nordlicht cluster reaches full FID at 1.6 GW</h3>
    <p>
      Vattenfall confirmed full FID for the Nordlicht offshore wind cluster,
      comprising Nordlicht 1 (980 MW) and Nordlicht 2 (630 MW), totalling 1.6
      GW. The projects will be delivered in phases and are expected to be fully
      operational around 2028, reinforcing Germany’s long-term offshore wind
      expansion in the North Sea.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Nordlicht demonstrates the continued importance of permitting certainty.
      However, as North Sea projects converge in the construction phase,
      execution capacity—foundations, cables, vessels and ports—has become the
      true constraint. Strong interface management will be critical to
      maintaining schedules and project economics.
    </p>
    <h3>5. Poland’s first offshore wind auction awards a CfD to Baltyk 1</h3>
    <p>
      Poland awarded a Contract for Difference to the Baltyk 1 offshore wind
      project in its first competitive auction. With a planned capacity of
      around 1.5 GW, the project is expected to reach commercial operation
      around 2032. The award marks Poland’s transition from policy ambition to a
      bankable offshore wind market and sets a reference point for future
      projects.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Baltyk 1 is a milestone for the Baltic Sea, signalling its emergence as a
      scalable offshore wind region. As with other new markets, the main
      challenges lie not in resource availability but in grid readiness, port
      infrastructure and cross-border supply coordination. Project delivery
      performance will shape long-term investor confidence.
    </p>
    <h3>6. China installs a 20 MW-class offshore wind turbine</h3>
    <p>
      China reported the installation of a 20 MW-class offshore wind turbine,
      highlighting key parameters such as annual generation, blade length,
      overall height and installation vessel capability. The development
      reflects continued acceleration in the engineering deployment of
      ultra-large turbines.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Larger turbines can reduce unit counts per GW, but they also increase
      engineering, logistics and O&M complexity. For other markets, the lesson
      is clear: turbine upscaling must be matched by parallel investment in
      ports, vessels and operational systems, or delivery risks will rise.
    </p>
    <h3>
      7. US legal developments: Revolution Wind resumes, Empire Wind faces
      uncertainty
    </h3>
    <p>
      A US court has allowed Revolution Wind to resume construction after a
      temporary halt, with the project nearing completion. In contrast, Empire
      Wind faces a critical decision on whether construction can restart, with
      potentially material implications if delays persist. These cases highlight
      ongoing legal and policy uncertainty during the construction phase.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The US experience is reshaping risk perceptions across financing,
      insurance and contracting. Regulatory stability is becoming as important
      as resource quality and support mechanisms. Developers and suppliers will
      increasingly rely on geographic diversification and flexible asset
      deployment to manage jurisdictional volatility.
    </p>
    <p>
      Developers are likely to respond by strengthening change-in-law
      protections and termination compensation mechanisms in future contracts.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
